import { batch, computed, signal } from "@preact/signals-react"

import { SELLER_DETAILS_KPI } from "../@constants"
import { isLoadingProductDetailsEvolution, productDetailsEvolutionsAllData, productDetailsEvolutionAllSellers, productDetailsEvolutionSkuData } from "./evolution"
import { isLoadingProductDetailsEvolutionTable, productDetailsEvolutionTableAllData, productDetailsEvolutionTableDates } from "./evolutionDetails"
import { isLoadingSellerProductsDetails, sellerProductDetailsData } from "./products"
import { isLoadingSellerDetails, sellerDetailsData } from "./seller"

export const sellerDetailsKpi = signal(SELLER_DETAILS_KPI.SELLER)
export const isSellerDetailsEmpty = signal(false)

// computed
export const isLoadingSellerDetailsPage = computed(() =>
	isLoadingSellerDetails.value
	|| isLoadingSellerProductsDetails.value
	|| isLoadingProductDetailsEvolution.value
	|| isLoadingProductDetailsEvolutionTable.value
)
export const isSellerDetailsProductKpi = computed(() => sellerDetailsKpi.value === SELLER_DETAILS_KPI.PRODUCT)

export const resetMarketplacesSellerDetails = () => batch(() => {
	productDetailsEvolutionsAllData.value = {}
	productDetailsEvolutionAllSellers.value = {}
	productDetailsEvolutionSkuData.value = []
	productDetailsEvolutionTableAllData.value = {}
	productDetailsEvolutionTableDates.value = []
	sellerProductDetailsData.value = []
	sellerDetailsData.value = []
	isSellerDetailsEmpty.value = false
})